import 'react-simple-keyboard/build/css/index.css';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import NumericKeyboard from './components/NumericKeyboard';
import MobileKeyboard from './components/MobileKeyboard';
import Styled from './PinPad.style';

const PinPad = (props) => {
  const theme = useTheme();
  const keyboard = React.createRef();
  // Initialize to empty string to avoid undefined in stale closures
  const [input, setInput] = React.useState('');
  // Mirror input in a ref so onKeyPress always reads the latest value,
  // regardless of when react-simple-keyboard captured the callback.
  const inputRef = React.useRef('');
  const [showPassword, setShowPassword] = React.useState(false);

  const { title, onSubmit, layout } = props;

  const onChange = (newInput) => {
    inputRef.current = newInput;
    setInput(newInput);
  };

  const onChangeInput = (e) => {
    const { value } = e.target;
    inputRef.current = value;
    setInput(value);
  };

  const onKeyPress = (button) => {
    if (button === '{bksp}') {
      const trimmed = inputRef.current.slice(0, inputRef.current.length - 1);
      inputRef.current = trimmed;
      setInput(trimmed);
    } else if (button === '{enter}' || button === '{return}') {
      onSubmit(inputRef.current);
      inputRef.current = '';
      setInput('');
    }
  };

  // Also support submitting by pressing the physical Enter key inside the input
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit(inputRef.current);
      inputRef.current = '';
      setInput('');
    }
  };

  const KeyboardComponent = layout === 'numpad' ? NumericKeyboard : MobileKeyboard;

  return (
    <Styled theme={theme}>
      <div className="keyboard__header">
        {title && (
          <Typography sx={{ fontSize: 10, mb: 1, fontWeight: 'light' }} variant="caption">
            {title}
          </Typography>
        )}

        <InputBase
          autoFocus
          autoComplete="off"
          className="calc-input"
          value={input}
          type={showPassword ? 'text' : 'password'}
          onChange={onChangeInput}
          onKeyDown={onKeyDown}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </div>
      <KeyboardComponent onChange={onChange} onKeyPress={onKeyPress} />
    </Styled>
  );
};

PinPad.defaultProps = {
  layout: 'numpad',
  onSubmit: () => false,
};

export default PinPad;
